import React from 'react'
import Back from '../../units/Back/Back'
import { useNavigate } from 'react-router-dom'

const Contacts = () => {
  const navigate = useNavigate()

  return (
    <div>
      <Back
        goBack={() => {
          navigate('/')
        }}
      />
      <h1 style={{ marginTop: 16 }}>Контакты</h1>
      <p>
        Компания: Алкомиг 96
        <br />
        Гео: Екб и пригород
        <br />
        Телефон: <a href="tel:+73433190519">+7 (343) 319-05-19</a>
        <br />
        Сайт:{' '}
        <a href="https://alcomig96.com" target="_blank" rel="noopener noreferrer">
          alcomig96.com
        </a>
        <br />
        ТГ бот: <a href="https://t.me/Alco_ekb_bot">alco_ekb_bot</a>
        <br />
        ТГ канал: <a href="https://t.me/alkomi">https://t.me/alkomi</a>
      </p>
    </div>
  )
}

export default Contacts
